import { createStyle } from '@gluestack-style/react';

export const InputAccessoryView = createStyle({});
